var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Rates.less');

module.exports = Section.extend({

    el: '.Rates',


    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Rates/Rates.js
// module id = 291
// module chunks = 0